import { ImageDimensions } from './image-dimensions.model';

export class ImageSourcePair {
    constructor(
        public dimensions: ImageDimensions,
        public breakpoint: number
    ) {}

    /**
     * @deprecated Use `.dimensions` instead
     */
    get dim(): ImageDimensions {
        console.warn('[ImageSourcePair] `dim` is deprecated. Use `dimensions` instead.');
        return this.dimensions;
    }

    /**
     * @deprecated Use `.breakpoint` instead
     */
    get br(): number {
        console.warn('[ImageSourcePair] `br` is deprecated. Use `breakpoint` instead.');
        return this.breakpoint;
    }
}
